import React from "react";

export default function ResultTableOtherRelease({
  currentQty,
  qty,
  onChangeQty,
}) {
  const table = {
    header: [
      {
        id: 1,
        title: "재고수량",
      },
      {
        id: 2,
        title: "기타 출고수량",
      },
    ],
  };
  return (
    <>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center text-black">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd] font-normal"
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="px-3 py-1 border border-[#dddddd]">
                {currentQty}
              </td>
              <td className="px-3 py-1 border border-[#dddddd]">
                <input
                  type="number"
                  onChange={onChangeQty}
                  value={qty}
                  className={`border rounded-[4px] p-[6px] ${
                    qty >= currentQty
                      ? "border-[#FF0000] outline-[#FF0000]"
                      : "border-button-grey outline-none"
                  }`}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
